module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Light.e76cd463.woff";